import { render, staticRenderFns } from "./PostCreation_ModalSection_Header.vue?vue&type=template&id=3a9e9987&scoped=true&"
import script from "./PostCreation_ModalSection_Header.vue?vue&type=script&lang=js&"
export * from "./PostCreation_ModalSection_Header.vue?vue&type=script&lang=js&"
import style0 from "./PostCreation_ModalSection_Header.vue?vue&type=style&index=0&id=3a9e9987&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e9987",
  null
  
)

export default component.exports